import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {AuthGuardService} from '../../../guards/auth-guard.service';
import {PagesComponent} from './pages.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.pages.pageInRouting,
    data: {data: PAGES_AND_PATHS.pages},
    component: PagesComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./pages.module').then(m => m.PagesModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
